import "./Footer.scss";

export default function Footer() {
    return (
        <div id="Footer">
            <h3>Contact par e-mail uniquement :</h3>
            <a href="mailto:kdprod@kdprod.fr">kdprod@kdprod.fr</a>
        </div>
    );
}